import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const offer = useConnect('offer.byId', {
    id: Number(match.params.offerId)
  })

  if (offer.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      offer={offer}
      page="Professional Competencies"
      title="Which of these competencies will your offer help students develop?"
      description="Select all that apply."
    >
      <Form
        user={user}
        offer={offer}
        navigation={(
          <Navigation v5={true} activeStep={10} steps={16}/>
        )}
        onPrevious={(newData) => history.push(Urls(offer).DESIGN)}
        onNext={(newData) => history.push(Urls(offer).DATE)}
        onSkip={() => history.push(Urls(offer).DATE)}
        onExit={() => history.push(Urls(offer).OFFER_EDIT)}
      />
    </ParentLayout>
  );
};
